import { CreatePodcastSubscriptionResponse } from './types';

export type CreatePodcastSubscriptionParameters = {
  webStationId: string;
  email: string;
  name: string;
  stripePaymentToken: string;
};

export async function createPodcastSubscription({
  webStationId,
  email,
  name,
  stripePaymentToken,
}: CreatePodcastSubscriptionParameters): Promise<
  CreatePodcastSubscriptionResponse
> {
  try {
    const body = {
      email,
      name,
      token: {
        id: stripePaymentToken,
      },
    };
    const response = await fetch(
      `/api/proxy/v3/podcastSubscriptions/webStationId:${webStationId}/subscribe`,
      {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(body),
      }
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error(`Could not update create subscription.`);
  } catch (err) {
    throw new Error(err.message);
  }
}
